document.addEventListener('DOMContentLoaded', function () {
  var container = document.getElementById('HairtonesFilters');
  var productGrid = document.getElementById('product-grid');
  var emptyState = document.getElementById('HairtonesEmptyState');

  if (!productGrid) return;

  var urlSortParam = new URLSearchParams(window.location.search).get('sort_by');
  var activeSort = urlSortParam || 'best-selling';

  var activeColor = null;
  var activeAccessory = null;
  var activeProductTags = [];
  var activeBenefitTags = [];

  var DRAWER_STATE_KEY = 'hairtonesDrawerState';

  var bestSellingRankMap = null;
  try {
    var bsJson = document.getElementById('HairtonesBestSellingIdOrder');
    if (bsJson && bsJson.textContent) {
      var parsedIds = JSON.parse(bsJson.textContent.trim());
      if (Array.isArray(parsedIds) && parsedIds.length > 0) {
        bestSellingRankMap = {};
        parsedIds.forEach(function (id, idx) {
          bestSellingRankMap[String(id)] = idx;
        });
      }
    }
  } catch (e) {}

  function sortKeyNum(el, attr) {
    var v = parseInt(el.getAttribute('data-sort-' + attr), 10);
    return isNaN(v) ? 0 : v;
  }

  function getSortComparator(sort) {
    switch (sort) {
      case 'price-ascending':
        return function (a, b) {
          return sortKeyNum(a, 'price') - sortKeyNum(b, 'price');
        };
      case 'price-descending':
        return function (a, b) {
          return sortKeyNum(b, 'price') - sortKeyNum(a, 'price');
        };
      case 'created-descending':
        return function (a, b) {
          return sortKeyNum(b, 'published') - sortKeyNum(a, 'published');
        };
      case 'best-selling':
        if (!bestSellingRankMap) return null;
        return function (a, b) {
          var ida = a.getAttribute('data-product-id');
          var idb = b.getAttribute('data-product-id');
          var ra = bestSellingRankMap[ida];
          var rb = bestSellingRankMap[idb];
          if (ra === undefined) ra = 1e9;
          if (rb === undefined) rb = 1e9;
          return ra - rb;
        };
      default:
        return null;
    }
  }

  function sortProductGrid() {
    if (productGrid.hasAttribute('data-product-groups')) return;

    var cmp = getSortComparator(activeSort);
    if (!cmp) return;

    var children = Array.prototype.slice.call(productGrid.children);
    var prefix = [];
    var products = [];
    children.forEach(function (el) {
      if (el.matches && el.matches('.grid__item[data-hairtone]')) {
        products.push(el);
      } else {
        prefix.push(el);
      }
    });

    products.sort(cmp);
    prefix.concat(products).forEach(function (el) {
      productGrid.appendChild(el);
    });
  }

  function replaceUrlSort(sort) {
    if (!sort) return;
    var u = new URL(window.location.href);
    if (u.searchParams.get('sort_by') === sort) return;
    u.searchParams.set('sort_by', sort);
    history.replaceState({}, '', u.toString());
  }

  // Hairtones collection only: sync Hair Tone / Accessory / Shop by Product filters
  // to URL hash, e.g. #silver-fox, #silver-fox/luovo, #luovo, #elastics, #luovo+claw-clips.
  // Does not touch Shopify's sort_by.
  var urlFilterSyncEnabled = !!container;
  var applyingUrlFilterState = false;

  function buildFilterHash(hairtone, accessory, productHandles) {
    var secondParts = [];
    if (accessory) secondParts.push(accessory);
    (productHandles || []).forEach(function (handle) {
      if (handle && secondParts.indexOf(handle) === -1) secondParts.push(handle);
    });
    var second = secondParts.join('+');
    if (hairtone && second) return '#' + hairtone + '/' + second;
    if (hairtone) return '#' + hairtone;
    if (second) return '#' + second;
    return '';
  }

  function parseFilterTokens(value) {
    return String(value || '')
      .split('+')
      .map(function (token) {
        return token.trim();
      })
      .filter(Boolean);
  }

  function parseFilterHash() {
    var raw = String(window.location.hash || '')
      .replace(/^#/, '')
      .trim();

    // Legacy query-param links from the first implementation.
    if (!raw) {
      var params = new URLSearchParams(window.location.search);
      var legacyAccessory = params.get('accessory');
      var legacyProduct = params.get('product');
      var restTokens = parseFilterTokens(legacyAccessory).concat(parseFilterTokens(legacyProduct));
      return {
        hairtone: params.get('hairtone'),
        restTokens: restTokens,
        fromLegacyQuery: !!(params.get('hairtone') || restTokens.length)
      };
    }

    var parts = raw.split('/');
    var hairtonePart = (parts[0] || '').trim();
    var restPart = (parts[1] || '').trim();

    return {
      hairtone: !hairtonePart || hairtonePart === 'all' ? null : hairtonePart,
      restTokens: parseFilterTokens(restPart),
      fromLegacyQuery: false
    };
  }

  function syncFiltersToUrl(options) {
    if (!urlFilterSyncEnabled) return;
    options = options || {};

    var u = new URL(window.location.href);
    var hadLegacyQuery =
      u.searchParams.has('hairtone') ||
      u.searchParams.has('accessory') ||
      u.searchParams.has('product');
    var nextHash = buildFilterHash(
      activeColor || null,
      activeAccessory || null,
      getUnmappedProductHandles()
    );
    var currentHash = window.location.hash || '';

    if (!hadLegacyQuery && currentHash === nextHash) return;

    u.searchParams.delete('hairtone');
    u.searchParams.delete('accessory');
    u.searchParams.delete('product');
    u.hash = nextHash ? nextHash.replace(/^#/, '') : '';

    var method = options.replace ? 'replaceState' : 'pushState';
    history[method]({}, '', u.pathname + u.search + (nextHash || ''));
  }

  function syncDrawerSort(value) {
    var drawer = document.getElementById('CollectionsFilterDrawer');
    if (!drawer) return;
    drawer.querySelectorAll('[data-sort-value]').forEach(function (btn) {
      btn.classList.toggle('is-selected', btn.dataset.sortValue === value);
    });
  }

  function normalizeHairtone(value) {
    if (value === 'clear') return 'blonde-bombshell';
    if (value === 'chocolate-tort') return 'chocolate-glaze';
    return String(value || '').replace(/_/g, '-');
  }

  function parseHairtoneTokens(attr) {
    if (!attr) return [];
    return attr
      .split('|')
      .map(function (token) {
        return normalizeHairtone(token.trim());
      })
      .filter(Boolean);
  }

  function productHairtoneTokens(item) {
    var fromAll = parseHairtoneTokens(item.dataset.hairtones || '');
    if (fromAll.length) return fromAll;
    var fallback = normalizeHairtone(item.dataset.hairtone || '');
    return fallback ? [fallback] : [];
  }

  function productHasHairtone(item, color) {
    if (!color) return true;
    var target = normalizeHairtone(color);
    return productHairtoneTokens(item).some(function (token) {
      return token === target;
    });
  }

  function getSwatchHairtoneHandle(swatch) {
    if (swatch.dataset.hairtoneHandle) {
      return normalizeHairtone(swatch.dataset.hairtoneHandle);
    }
    return normalizeHairtone(swatch.dataset.swatchValue || '');
  }

  function switchCardToHairtone(item, color) {
    if (!color) {
      delete item.dataset.filterHairtone;
      return;
    }

    var targetHandle = normalizeHairtone(color);
    if (item.dataset.filterHairtone === targetHandle) return;

    var card = item.querySelector('.card-wrapper.product-card-wrapper');
    if (!card) return;

    var targetSwatch = null;
    var fallbackSwatch = null;
    card.querySelectorAll('.card-swatch').forEach(function (swatch) {
      if (getSwatchHairtoneHandle(swatch) !== targetHandle) return;
      if (!swatch.disabled) {
        targetSwatch = swatch;
      } else if (!fallbackSwatch) {
        fallbackSwatch = swatch;
      }
    });

    targetSwatch = targetSwatch || fallbackSwatch;

    if (!targetSwatch) return;
    if (targetSwatch.classList.contains('active') && targetSwatch.checked) {
      item.dataset.filterHairtone = targetHandle;
      return;
    }

    item.dataset.filterHairtone = targetHandle;
    targetSwatch.checked = true;
    targetSwatch.dispatchEvent(
      new CustomEvent('change', { bubbles: true, detail: { fromHairtoneFilter: true } })
    );
  }

  function getProductFamilyKey(item) {
    var key = (item.dataset.productFamily || '').trim().toLowerCase();
    if (key) return key;

    var card = item.querySelector('.card-wrapper.product-card-wrapper');
    if (card) {
      var titleEl = card.querySelector('.pdp-title');
      if (titleEl) {
        return titleEl.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      }
    }

    return item.dataset.productId ? 'id:' + item.dataset.productId : '';
  }

  function cardHasHairtoneSwatch(item, color) {
    if (!color) return false;
    var targetHandle = normalizeHairtone(color);
    var card = item.querySelector('.card-wrapper.product-card-wrapper');
    if (!card) return false;

    var swatches = card.querySelectorAll('.card-swatch');
    for (var i = 0; i < swatches.length; i++) {
      if (getSwatchHairtoneHandle(swatches[i]) === targetHandle) {
        return true;
      }
    }
    return false;
  }

  function pickProductFamilyWinner(candidates, color) {
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];

    if (color) {
      var target = normalizeHairtone(color);
      var exactMatch = null;
      var swatchMatch = null;

      candidates.forEach(function (item) {
        if (normalizeHairtone(item.dataset.hairtone || '') === target) {
          exactMatch = item;
        } else if (!swatchMatch && cardHasHairtoneSwatch(item, target)) {
          swatchMatch = item;
        }
      });

      if (exactMatch) return exactMatch;
      if (swatchMatch) return swatchMatch;
    }

    return candidates[0];
  }

  function deduplicateProductFamilies(visibleItems, color) {
    if (!visibleItems.length) return [];

    var familyGroups = {};
    visibleItems.forEach(function (item) {
      var key = getProductFamilyKey(item) || 'id:' + (item.dataset.productId || Math.random());
      if (!familyGroups[key]) familyGroups[key] = [];
      familyGroups[key].push(item);
    });

    var winners = [];
    Object.keys(familyGroups).forEach(function (key) {
      var group = familyGroups[key];
      if (group.length === 1) {
        winners.push(group[0]);
        return;
      }

      var winner = pickProductFamilyWinner(group, color);
      winners.push(winner);
      group.forEach(function (item) {
        if (item !== winner) {
          item.style.display = 'none';
          delete item.dataset.filterHairtone;
        }
      });
    });

    return winners;
  }

  var hairtoneButtons = container ? container.querySelectorAll('[data-hairtone]') : [];
  var accessoryButtons = container ? container.querySelectorAll('[data-accessory]') : [];

  function syncPressedState(buttons, activeButton) {
    buttons.forEach(function (b) {
      b.setAttribute('aria-pressed', b === activeButton ? 'true' : 'false');
    });
  }

  if (container) {
    syncPressedState(hairtoneButtons, container.querySelector('[data-hairtone].hairtones-filter-btn--active'));
    syncPressedState(accessoryButtons, container.querySelector('[data-accessory].hairtones-filter-btn--active'));

    function isDesktop() {
      return window.matchMedia('(min-width: 750px)').matches;
    }

    function initHairtoneTooltips() {
      if (!isDesktop()) return;

      hairtoneButtons.forEach(function (btn) {
        if (btn.dataset.hairtone === 'all') return;

        var tooltip = btn.querySelector('.hairtones-filter-tooltip');
        if (!tooltip) return;

        btn.addEventListener('mouseenter', function () {
          container.querySelectorAll('.hairtones-filter-tooltip--visible').forEach(function (t) {
            t.classList.remove('hairtones-filter-tooltip--visible');
            t.setAttribute('aria-hidden', 'true');
          });
          tooltip.classList.add('hairtones-filter-tooltip--visible');
          tooltip.setAttribute('aria-hidden', 'false');
        });

        btn.addEventListener('mouseleave', function () {
          tooltip.classList.remove('hairtones-filter-tooltip--visible');
          tooltip.setAttribute('aria-hidden', 'true');
        });
      });
    }

    initHairtoneTooltips();

    hairtoneButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.dataset.hairtone;
        activeColor = (value === 'all' || value === '') ? null : normalizeHairtone(value);

      hairtoneButtons.forEach(function (b) {
        b.classList.remove('hairtones-filter-btn--active');
      });
      btn.classList.add('hairtones-filter-btn--active');
      syncPressedState(hairtoneButtons, btn);

      syncDrawerHairtone(value);
      applyFilters();
      syncFiltersToUrl();
    });
  });

  accessoryButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.dataset.accessory;
      activeAccessory = value === 'all' || value === '' ? null : value;

      accessoryButtons.forEach(function (b) {
        b.classList.remove('hairtones-filter-btn--active');
      });
      btn.classList.add('hairtones-filter-btn--active');
      syncPressedState(accessoryButtons, btn);

      syncDrawerMappedProductCheckboxes(activeAccessory);
      applyFilters();
      syncFiltersToUrl();
    });
  });
  }

  function syncDrawerHairtone(value) {
    var drawer = document.getElementById('CollectionsFilterDrawer');
    if (!drawer) return;

    drawer.querySelectorAll('[data-drawer-hairtone]').forEach(function (btn) {
      var isMatch = btn.dataset.drawerHairtone === value || (value === 'all' && btn.dataset.drawerHairtone === 'all');
      btn.classList.toggle('is-selected', isMatch);
    });
  }

  function syncTopBarHairtone(handle) {
    if (!container) return;

    var targetValue = handle === 'all' || !handle ? 'all' : normalizeHairtone(handle);
    hairtoneButtons.forEach(function (btn) {
      var btnValue = btn.dataset.hairtone;
      var isMatch =
        targetValue === 'all'
          ? btnValue === 'all'
          : btnValue !== 'all' && normalizeHairtone(btnValue) === targetValue;
      btn.classList.toggle('hairtones-filter-btn--active', isMatch);
    });
    syncPressedState(
      hairtoneButtons,
      container.querySelector('[data-hairtone].hairtones-filter-btn--active')
    );
  }

  function syncTopBarAccessory(handle) {
    if (!container) return;

    var targetValue = handle === 'all' || !handle ? 'all' : handle;
    accessoryButtons.forEach(function (btn) {
      var isMatch = btn.dataset.accessory === targetValue;
      btn.classList.toggle('hairtones-filter-btn--active', isMatch);
    });
    syncPressedState(
      accessoryButtons,
      container.querySelector('[data-accessory].hairtones-filter-btn--active')
    );
  }

  function hasHairtoneOption(handle) {
    if (!handle || handle === 'all') return false;
    var normalized = normalizeHairtone(handle);
    for (var i = 0; i < hairtoneButtons.length; i++) {
      var value = hairtoneButtons[i].dataset.hairtone;
      if (value && value !== 'all' && normalizeHairtone(value) === normalized) {
        return true;
      }
    }
    return false;
  }

  function normalizeFilterKey(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[''™®]/g, '')
      .replace(/[^a-z0-9]+/g, '');
  }

  function toHandle(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/['']/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function getDrawerProductInputs() {
    var drawer = document.getElementById('CollectionsFilterDrawer');
    if (!drawer) return [];
    return Array.prototype.slice.call(drawer.querySelectorAll('[data-filter-product]'));
  }

  function getProductFilterHandle(label) {
    var inputs = getDrawerProductInputs();
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].dataset.filterProduct === label && inputs[i].dataset.filterHandle) {
        return inputs[i].dataset.filterHandle;
      }
    }
    return toHandle(label);
  }

  function getProductLabelForHandle(handle) {
    if (!handle) return null;
    var key = normalizeFilterKey(handle);
    var inputs = getDrawerProductInputs();
    for (var i = 0; i < inputs.length; i++) {
      var label = inputs[i].dataset.filterProduct;
      var dataHandle = inputs[i].dataset.filterHandle || '';
      if (dataHandle === handle || toHandle(label) === handle) return label;
      if (normalizeFilterKey(label) === key) return label;
      if (dataHandle && normalizeFilterKey(dataHandle) === key) return label;
    }
    return null;
  }

  function hasProductFilterOption(handle) {
    return !!getProductLabelForHandle(handle);
  }

  function getAccessoryHandleFromToken(token) {
    if (!token || token === 'all') return null;
    var key = normalizeFilterKey(token);
    if (!key) return null;
    for (var i = 0; i < accessoryButtons.length; i++) {
      var handle = accessoryButtons[i].dataset.accessory;
      if (!handle || handle === 'all') continue;
      if (handle === token || normalizeFilterKey(handle) === key) return handle;
      var title = accessoryButtons[i].getAttribute('title') || '';
      if (title && normalizeFilterKey(title) === key) return handle;
    }
    return null;
  }

  function hasAccessoryOption(handle) {
    return !!getAccessoryHandleFromToken(handle);
  }

  function getAccessoryHandleForProductLabel(label) {
    if (!label) return null;
    var fromToken = getAccessoryHandleFromToken(label) || getAccessoryHandleFromToken(toHandle(label));
    if (fromToken) return fromToken;
    return getAccessoryHandleFromToken(normalizeFilterKey(label));
  }

  function getProductLabelForAccessoryHandle(accessoryHandle) {
    if (!accessoryHandle) return null;
    var inputs = getDrawerProductInputs();
    for (var i = 0; i < inputs.length; i++) {
      if (getAccessoryHandleForProductLabel(inputs[i].dataset.filterProduct) === accessoryHandle) {
        return inputs[i].dataset.filterProduct;
      }
    }
    return null;
  }

  function getUnmappedProductHandles() {
    var handles = [];
    (activeProductTags || []).forEach(function (label) {
      if (getAccessoryHandleForProductLabel(label)) return;
      var handle = getProductFilterHandle(label);
      if (handle && handles.indexOf(handle) === -1) handles.push(handle);
    });
    return handles;
  }

  function splitProductTagsAndAccessory(productTags) {
    var mapped = [];
    var unmapped = [];
    (productTags || []).forEach(function (label) {
      var accessoryHandle = getAccessoryHandleForProductLabel(label);
      if (accessoryHandle) {
        mapped.push({ label: label, accessory: accessoryHandle });
      } else {
        unmapped.push(label);
      }
    });

    var accessory;
    var productTagsOut = unmapped.slice();
    if (mapped.length === 1) {
      accessory = mapped[0].accessory;
    } else if (mapped.length > 1) {
      accessory = null;
      mapped.forEach(function (item) {
        productTagsOut.push(item.label);
      });
    }

    return { accessory: accessory, productTags: productTagsOut };
  }

  function syncDrawerProductCheckboxes(selectedLabels, accessoryHandle) {
    var selectedMap = {};
    (selectedLabels || []).forEach(function (label) {
      selectedMap[label] = true;
    });

    getDrawerProductInputs().forEach(function (input) {
      var label = input.dataset.filterProduct;
      var mappedAccessory = getAccessoryHandleForProductLabel(label);
      var checked = !!selectedMap[label];
      if (accessoryHandle && mappedAccessory === accessoryHandle) checked = true;
      input.checked = checked;
    });
  }

  function syncDrawerMappedProductCheckboxes(accessoryHandle) {
    getDrawerProductInputs().forEach(function (input) {
      var mappedAccessory = getAccessoryHandleForProductLabel(input.dataset.filterProduct);
      if (!mappedAccessory) return;
      input.checked = !!(accessoryHandle && mappedAccessory === accessoryHandle);
    });
  }

  function applyUrlFilterState(options) {
    if (!urlFilterSyncEnabled) return;
    options = options || {};

    applyingUrlFilterState = true;

    var parsed = parseFilterHash();
    var urlHairtone = parsed.hairtone;
    var restTokens = (parsed.restTokens || []).slice();

    // Single-segment hash that matches an accessory or shop-by-product filter,
    // e.g. #luovo or #elastics+claw-clips. Legacy #all/luovo is still accepted.
    if (urlHairtone && !restTokens.length && !hasHairtoneOption(urlHairtone)) {
      var firstTokens = parseFilterTokens(urlHairtone);
      var looksLikeFilter = firstTokens.some(function (token) {
        return hasAccessoryOption(token) || hasProductFilterOption(token);
      });
      if (looksLikeFilter) {
        restTokens = firstTokens;
        urlHairtone = null;
      }
    }

    var urlAccessory = null;
    var urlProductLabels = [];
    restTokens.forEach(function (token) {
      var accessoryHandle = getAccessoryHandleFromToken(token);
      if (accessoryHandle) {
        if (!urlAccessory) {
          urlAccessory = accessoryHandle;
        } else {
          var extraLabel = getProductLabelForHandle(token);
          if (extraLabel && urlProductLabels.indexOf(extraLabel) === -1) {
            urlProductLabels.push(extraLabel);
          }
        }
        return;
      }

      var productLabel = getProductLabelForHandle(token);
      if (!productLabel) return;

      var mappedAccessory = getAccessoryHandleForProductLabel(productLabel);
      if (mappedAccessory && !urlAccessory) {
        urlAccessory = mappedAccessory;
        return;
      }
      if (urlProductLabels.indexOf(productLabel) === -1) {
        urlProductLabels.push(productLabel);
      }
    });

    if (!options.skipHairtone) {
      if (urlHairtone && hasHairtoneOption(urlHairtone)) {
        activeColor = normalizeHairtone(urlHairtone);
      } else {
        activeColor = null;
      }
      syncTopBarHairtone(activeColor || 'all');
      syncDrawerHairtone(activeColor || 'all');
    }

    activeAccessory = urlAccessory || null;
    syncTopBarAccessory(activeAccessory || 'all');

    if (urlProductLabels.length) {
      activeProductTags = urlProductLabels;
    } else if (!options.skipHairtone) {
      activeProductTags = [];
    }

    syncDrawerProductCheckboxes(activeProductTags, activeAccessory);
    setHairtoneAvailability(activeProductTags, activeBenefitTags);
    applyFilters();

    // Normalize aliases / legacy ?hairtone=&accessory= into canonical hash.
    syncFiltersToUrl({ replace: true });
    applyingUrlFilterState = false;
  }

  function tagMatchesAny(tagsAttr, filterTags) {
    if (!filterTags.length) return true;
    var tags = tagsAttr.length > 0 ? tagsAttr.split(',') : [];
    return filterTags.some(function (filterTag) {
      return tags.some(function (t) {
        return t.trim() === filterTag;
      });
    });
  }

  function productFilterMatchesAny(productFiltersAttr, activeFilters) {
    if (!activeFilters.length) return true;
    var productFilters = productFiltersAttr.length > 0 ? productFiltersAttr.split(',') : [];
    return activeFilters.some(function (activeFilter) {
      return productFilters.some(function (pf) {
        return pf.trim() === activeFilter;
      });
    });
  }

  function getAvailableHairtonesForFilters(productTags, benefitTags) {
    productTags = productTags || [];
    benefitTags = benefitTags || [];
    if (!productTags.length && !benefitTags.length) return null;

    var available = {};
    var items = productGrid.querySelectorAll('.grid__item[data-hairtone]');
    items.forEach(function (item) {
      var productFiltersAttr = item.dataset.productFilters || '';
      var matchesProduct = productFilterMatchesAny(productFiltersAttr, productTags);
      var matchesBenefit = productFilterMatchesAny(productFiltersAttr, benefitTags);
      if (matchesProduct && matchesBenefit) {
        productHairtoneTokens(item).forEach(function (hairtone) {
          if (hairtone) available[hairtone] = true;
        });
      }
    });
    return available;
  }

  function isHairtoneUnavailable(handle, productTags, benefitTags) {
    if (!handle || handle === 'all') return false;

    var drawer = document.getElementById('CollectionsFilterDrawer');
    if (drawer) {
      var drawerBtn = drawer.querySelector('[data-drawer-hairtone="' + handle + '"]');
      if (drawerBtn && drawerBtn.dataset.hairtoneInCollection === 'false') return true;
    }

    productTags = productTags || [];
    benefitTags = benefitTags || [];
    if (!productTags.length && !benefitTags.length) return false;

    var available = getAvailableHairtonesForFilters(productTags, benefitTags);
    return !available || !available[normalizeHairtone(handle)];
  }

  function setHairtoneAvailability(productTags, benefitTags) {
    var hasProductOrBenefitFilter = (productTags && productTags.length) || (benefitTags && benefitTags.length);
    var availableMap = getAvailableHairtonesForFilters(productTags, benefitTags);

    function updateButton(btn, handle) {
      if (!handle || handle === 'all') {
        btn.classList.remove('is-unavailable');
        btn.removeAttribute('aria-disabled');
        return;
      }

      var notInCollection = btn.dataset.hairtoneInCollection === 'false';
      var unavailable = notInCollection || (hasProductOrBenefitFilter && (!availableMap || !availableMap[normalizeHairtone(handle)]));
      btn.classList.toggle('is-unavailable', unavailable);
      btn.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      if (unavailable) {
        btn.classList.remove('is-selected', 'hairtones-filter-btn--active');
      }
    }

    var drawer = document.getElementById('CollectionsFilterDrawer');
    if (drawer) {
      drawer.querySelectorAll('[data-drawer-hairtone]').forEach(function (btn) {
        updateButton(btn, btn.dataset.drawerHairtone);
      });
    }

    if (container) {
      hairtoneButtons.forEach(function (btn) {
        updateButton(btn, btn.dataset.hairtone);
      });
      syncPressedState(
        hairtoneButtons,
        container.querySelector('[data-hairtone].hairtones-filter-btn--active')
      );
    }
  }

  function formatProductCount(count) {
    return count + ' ' + (count === 1 ? 'Product' : 'Products');
  }

  function updateProductCountDisplay(count) {
    var countEl = document.querySelector('[data-collections-filter-count]');
    if (countEl) {
      countEl.textContent = formatProductCount(count);
    }
  }

  var hairtoneSyncGeneration = 0;

  function yieldToMain() {
    if (globalThis.scheduler && typeof globalThis.scheduler.yield === 'function') {
      return globalThis.scheduler.yield();
    }
    return new Promise(function (resolve) {
      setTimeout(resolve, 0);
    });
  }

  function syncHairtoneCardsInChunks(items, generation, color) {
    var i = 0;

    function runChunk() {
      if (generation !== hairtoneSyncGeneration) return;
      var start = performance.now();
      while (i < items.length && performance.now() - start < 6) {
        switchCardToHairtone(items[i], color);
        i += 1;
      }
      if (i < items.length) {
        yieldToMain().then(runChunk);
      }
    }

    runChunk();
  }

  function syncGroupedCards() {
    if (!productGrid.hasAttribute('data-product-groups')) return;

    var cards = productGrid.querySelectorAll('.grid__item[data-product-group-card]');
    cards.forEach(function (card) {
      var group = card.getAttribute('data-product-group');
      if (!group) return;

      var products = productGrid.querySelectorAll(
        '.grid__item[data-product-id][data-product-group="' + group + '"]'
      );
      var anyVisible = false;
      products.forEach(function (item) {
        if (item.style.display !== 'none') anyVisible = true;
      });
      card.style.display = anyVisible ? '' : 'none';

      var groupEnd = productGrid.querySelector(
        '.grid__item[data-product-group-end="' + group + '"]'
      );
      if (groupEnd) groupEnd.style.display = anyVisible ? '' : 'none';
    });

    var remainders = productGrid.querySelectorAll('.grid__item[data-product-group="remainder"]');
    var firstVisibleRemainder = null;
    remainders.forEach(function (item) {
      item.classList.remove('grid__item--group-start');
      if (!firstVisibleRemainder && item.style.display !== 'none') {
        firstVisibleRemainder = item;
      }
    });
    if (firstVisibleRemainder) {
      firstVisibleRemainder.classList.add('grid__item--group-start');
    }
  }

  function applyFilters() {
    var generation = ++hairtoneSyncGeneration;
    var items = productGrid.querySelectorAll('.grid__item[data-hairtone]');
    var visibleItems = [];

    items.forEach(function (item) {
      var tagsAttr = item.dataset.tags || '';

      var matchesColor = productHasHairtone(item, activeColor);

      var matchesAccessory = true;
      if (activeAccessory) {
        var tags = tagsAttr.length > 0 ? tagsAttr.split(',') : [];
        matchesAccessory = tags.some(function (t) {
          return t.trim() === activeAccessory;
        });
      }

      var productFiltersAttr = item.dataset.productFilters || '';
      var matchesProduct = productFilterMatchesAny(productFiltersAttr, activeProductTags);
      var matchesBenefit = productFilterMatchesAny(productFiltersAttr, activeBenefitTags);

      if (matchesColor && matchesAccessory && matchesProduct && matchesBenefit) {
        item.style.display = '';
        visibleItems.push(item);
      } else {
        item.style.display = 'none';
        delete item.dataset.filterHairtone;
      }
    });

    syncGroupedCards();

    var dedupedItems = activeColor
      ? deduplicateProductFamilies(visibleItems, activeColor)
      : visibleItems;
    var visibleCount = dedupedItems.length;
    var colorToApply = activeColor;

    if (emptyState) {
      emptyState.style.display = visibleCount === 0 ? '' : 'none';
    }

    updateProductCountDisplay(visibleCount);

    requestAnimationFrame(function () {
      if (generation !== hairtoneSyncGeneration) return;
      sortProductGrid();
      syncHairtoneCardsInChunks(dedupedItems, generation, colorToApply);
    });
  }

  function applySortByImpl(sortBy) {
    if (!sortBy) return;
    activeSort = sortBy;
    syncDrawerSort(activeSort);
    replaceUrlSort(activeSort);
    sortProductGrid();
  }

  window.HairtonesCollectionFilters = {
    applySortBy: applySortByImpl,
    applyFilters: applyFilters,
    needsBrowserReloadForBestSelling: function () {
      return !bestSellingRankMap;
    },
    updateHairtoneAvailability: setHairtoneAvailability,
    isHairtoneUnavailable: isHairtoneUnavailable,
    applyFromDrawer: function (options) {
      options = options || {};
      var productTags = options.productTags || [];
      var benefitTags = options.benefitTags || [];
      var hairtone = options.hairtone || 'all';
      var split = splitProductTagsAndAccessory(productTags);

      activeProductTags = split.productTags;
      activeBenefitTags = benefitTags;
      if (split.accessory !== undefined) {
        activeAccessory = split.accessory;
      } else if (getProductLabelForAccessoryHandle(activeAccessory)) {
        activeAccessory = null;
      }

      setHairtoneAvailability(productTags, benefitTags);

      if (isHairtoneUnavailable(hairtone, productTags, benefitTags)) {
        hairtone = 'all';
      }

      activeColor = hairtone === 'all' ? null : normalizeHairtone(hairtone);

      if (options.sortBy) {
        applySortByImpl(options.sortBy);
      }

      syncTopBarHairtone(hairtone);
      syncTopBarAccessory(activeAccessory || 'all');
      syncDrawerProductCheckboxes(activeProductTags, activeAccessory);
      applyFilters();

      if (urlFilterSyncEnabled && options.skipUrlSync !== true) {
        syncFiltersToUrl({ replace: !!options.replaceUrl });
      }
    }
  };

  syncDrawerSort(activeSort);

  var restoredFromSession = false;
  try {
    var pending = sessionStorage.getItem(DRAWER_STATE_KEY);
    if (pending) {
      sessionStorage.removeItem(DRAWER_STATE_KEY);
      var state = JSON.parse(pending);
      if (state && typeof state === 'object') {
        window.HairtonesCollectionFilters.applyFromDrawer({
          hairtone: state.hairtone,
          productTags: state.productTags || [],
          benefitTags: state.benefitTags || [],
          skipUrlSync: true
        });
        restoredFromSession = true;
      }
    }
  } catch (e) {}

  if (urlFilterSyncEnabled) {
    // After best-selling reload, drawer hairtone comes from sessionStorage;
    // accessory, shop-by-product, and hairtone (when there is no session state) come from the hash.
    applyUrlFilterState({ skipHairtone: restoredFromSession });

    window.addEventListener('popstate', function () {
      if (applyingUrlFilterState) return;
      applyUrlFilterState();
    });

    window.addEventListener('hashchange', function () {
      if (applyingUrlFilterState) return;
      applyUrlFilterState();
    });
  }
});
